export default {"src":"/_next/static/media/football_plane.4ddf3693.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};